import type { FileAudioUsage } from '@vedalib/editor/lib/files'
import { FileUsageTypeEnum } from '@vedalib/editor/lib/files'
import { FileTypeEnum } from 'utils'

import MediaPlayer from 'components/MediaPlayer'
import { useUrlByUsage } from 'utils/files'

import * as s from './AudioPreview.module.scss'

const AudioPreview = (value: FileAudioUsage) => {
  const mediaUrl = useUrlByUsage(value, FileUsageTypeEnum.audio)

  return (
    <div className={s.root}>
      <MediaPlayer type={FileTypeEnum.AUDIO} url={mediaUrl || null} />
    </div>
  )
}

export default AudioPreview
